import { render } from "./AdminFormationRegistrations.vue?vue&type=template&id=76bb775c&scoped=true"
import script from "./AdminFormationRegistrations.vue?vue&type=script&lang=js"
export * from "./AdminFormationRegistrations.vue?vue&type=script&lang=js"

import "./AdminFormationRegistrations.vue?vue&type=style&index=0&id=76bb775c&lang=css"
import "./AdminFormationRegistrations.vue?vue&type=style&index=1&id=76bb775c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bb775c"]])

export default __exports__